<template>
<div>
	<div class="wrap" v-if="isMobile">
		<div class="mdetail">
                <h2>{{title}}</h2>
                <i>发布时间：{{formatDate(date)}}  
					<template v-if="type==2"> 
						&nbsp;&nbsp; 来源：{{source}}
					</template>
				</i>
                <div class="main" v-html="content"> </div>
		</div>
	</div>
	<div v-else class="content">
            <div class="detail">
                <h2>{{title}}</h2>
                <i>发布时间：{{formatDate(date)}}  
					<template v-if="type==2"> 
						&nbsp;&nbsp; 来源：{{source}}
					</template>
				</i>
                <div class="main" v-html="content"> </div>
            </div>
	</div>
</div>
</template>
<style scoped>
/*  资讯详情  */
.detail {background:#fff;margin:20px 0;font-size:14px; padding-bottom:24px; min-height:640px;}
.detail h2{font-size: 24px;padding-top: 48px;color: #2a2a2a;text-align: center;}
.detail i{ display:block; font-style:normal;color: #aaa;text-align: center;margin-top: 16px;}


.mdetail {background:#fff;margin:1rem 0;font-size:1.2rem; padding-bottom:2.4rem; width:94%;  padding:0 3% 2.4rem; }
.mdetail h2{font-size:1.6rem;padding-top:2rem;color: #2a2a2a;text-align: center;}
.mdetail i{ display:block; font-style:normal;color: #aaa;text-align: center;margin:1rem 0;}
.mdetail p{font-size:1.2rem;}
.mdetail p img{width: 100%;}

</style>
<script>   
	export default {
		name: 'details1',
		methods: {
			detail(id){
				const self = this;
				self.http.ajaxGet("DocumentByID?ID="+id,function(res){
                if(res.ReturnCode == 1){
					self.title=res.Result[0].Title;
					self.content=res.Result[0].Content;
					self.source=res.Result[0].Source;
					self.date=res.Result[0].CreateDate;
					self.type=res.Result[0].Type;
                }else{
                    self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
                }	
                },function(err){
                    self.$alert(err, '错误', {confirmButtonText: '确定'});
                })
			},
			formatDate(date){
				return this.http.dateFormat1("yyyy-MM-dd",date);
        	}
		},
		data() {
			return {
				title:'',
				content:'',
				source:'',
				date:'',
				type:0
			}
		},
		computed:{
			isMobile(){
				return this.common.isMobile();
			}
		},
		mounted: function () {
			var id=this.$route.params.id;
			this.detail(id);

			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
			window.pageYOffset = 0;
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/details.vue